import React, { useState } from "react";
import { X } from "lucide-react";
import { gallery } from "../mock";
import useReveal from "../hooks/useReveal";

function Tile({ item, i, onOpen }) {
  const [ref, inView] = useReveal();
  const spanClass = i === 0 || i === 5 ? "lg:row-span-2" : "";
  return (
    <button
      ref={ref}
      onClick={() => onOpen(item)}
      className={`gallery-card relative overflow-hidden rounded-2xl group reveal ${
        inView ? "in-view" : ""
      } ${spanClass}`}
      style={{ animationDelay: `${i * 0.08}s` }}
    >
      <img
        src={item.img}
        alt={item.caption}
        className="gallery-img w-full h-full min-h-[220px] object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#2b2620]/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-400" />
      <span className="absolute bottom-4 left-4 text-white font-serif text-lg opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-400">
        {item.caption}
      </span>
    </button>
  );
}

export default function Gallery() {
  const [active, setActive] = useState(null);
  return (
    <section id="galerie" className="py-24 md:py-32 bg-secondary/50">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="eyebrow-line text-accent tracking-[0.3em] text-xs font-medium uppercase">
            Galerie
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-semibold mt-5 text-foreground">
            Boulogne-Billancourt
          </h2>
          <p className="text-muted-foreground mt-4 text-lg">
            Immeubles de caractère, quartiers résidentiels et bords de Seine : découvrez le cadre de vie où nous vous accompagnons.
          </p>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 auto-rows-[220px]">
          {gallery.map((item, i) => (
            <Tile key={i} item={item} i={i} onOpen={setActive} />
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {active && (
        <div
          className="fixed inset-0 z-[60] bg-[#1c1813]/90 backdrop-blur-sm flex items-center justify-center p-5"
          onClick={() => setActive(null)}
        >
          <button className="absolute top-6 right-6 text-white/80 hover:text-white" aria-label="Fermer">
            <X className="h-8 w-8" />
          </button>
          <div className="max-w-4xl w-full" onClick={(e) => e.stopPropagation()}>
            <img src={active.img} alt={active.caption} className="w-full max-h-[80vh] object-contain rounded-xl" />
            <p className="text-white/90 font-serif text-xl text-center mt-4">{active.caption}</p>
          </div>
        </div>
      )}
    </section>
  );
}
